<template>
	<b-modal
		header-class="header-class-modal-doc-package"
		v-model="isOpen"
		:title="forInvoice ? FormMSG(291, 'Report') : FormMSG(1, 'Format selection')"
		size="lg"
		hide-header-close
		centered
		cancel-variant="light"
		no-close-on-backdrop
		no-close-on-esc
	>
		<div class="animated fadeIn">
			<div class="container-layout form">
				<b-row v-if="forInvoice" class="align-items-center">
					<b-col cols="8">
						<b-form-group :label="FormMSG(291, 'Report')">
							<v-select
								v-model="reportType"
								label="name"
								:options="reportOptions"
								:reduce="(option) => option.id"
								:clearable="false"
								:appendToBody="true"
							>
								<template #option="option">
									<div class="d-flex justify-content-start align-items-center">
										<div class="d-flex flex-column justify-content-start">
											<div class="ml-2" :class="`${option.id ? 'label-script' : ''}`">
												{{ option.name }}
											</div>
										</div>
									</div>
								</template>
							</v-select>
						</b-form-group>
					</b-col>
					<b-col cols="4">
						<b-form-checkbox v-model="sendByMail" class="mt-2">
							<label class="label-mobile">{{ FormMSG(290, 'Send me by email') }}</label>
						</b-form-checkbox>
					</b-col>
				</b-row>
				<b-row v-if="(forInvoice && scripts.length > 1) || !forInvoice" class="align-items-center">
					<b-col cols="12">
						<b-form-group :label="forInvoice ? FormMSG(293, 'Layout') : FormMSG(4, 'Script')">
							<v-select
								v-model="scriptSelected"
								label="name"
								:options="scripts"
								:reduce="(option) => option.id"
								:clearable="false"
								@option:selected="handleScriptSelected"
								:appendToBody="true"
							>
								<template #option="option">
									<div class="d-flex justify-content-start align-items-center">
										<b-img
											width="32"
											height="32"
											rounded
											:src="`svgs/bootstrap/filetype-${OUTPUT_FORMAT_EXPORT.at(option.outputFileFormat)}.svg`"
											:alt="OUTPUT_FORMAT_EXPORT.at(option.outputFileFormat)"
											v-if="option.id"
										/>
										<div class="d-flex flex-column justify-content-start">
											<div class="ml-2" :class="`${option.id ? 'label-script' : ''}`">
												{{ option.name }}
											</div>
											<div class="ml-2 sub-label-script" v-if="option.id">
												{{ getFileName(option.fileName) }} | {{ FormMSG(13, 'Output') }}:
												<span class="text-uppercase font-weight-bold">{{
													getExtensionScript(
														OUTPUT_FORMAT_EXPORT.at(option.outputFileFormat),
														option.customExtension,
														getFileExt(option.fileName)
													)
												}}</span>
											</div>
										</div>
									</div>
								</template>
							</v-select>
							<!-- <div v-if="isSubmitted && !$v.scriptSelected.required" class="invalid-feedback">
								{{ FormMSG(6, 'Script is required') }}
							</div> -->
						</b-form-group>
					</b-col>
				</b-row>
			</div>
			<b-modal
				header-class="header-class-modal-doc-package"
				v-model="openLog"
				size="lg"
				ok-only
				ok-title-html
				centered
				:title="FormMSG(9, 'Log')"
				:ok-title="FormMSG(10, 'Close')"
				@ok="handleCloseLogWindow"
				@cancel="handleCloseLogWindow"
				@hidden="handleCloseLogWindow"
				no-close-on-backdrop
			>
				<b-card no-body>
					<b-card-text class="px-3 pb-3">
						<div v-html="importLog"></div>
					</b-card-text>
				</b-card>
			</b-modal>
		</div>
		<template #modal-footer>
			<div class="w-100 d-flex justify-content-end align-items-center">
				<b-col sm="4" md="4" lg="2" xl="2">
					<b-button size="md" variant="light" @click="emitEventClose" block :disabled="isLoading">
						{{ FormMSG(2, 'Cancel') }}
					</b-button>
				</b-col>
				<b-col sm="8" md="8" lg="3" xl="3">
					<b-button size="md" variant="primary" @click="sendReport" block :disabled="isLoading || !canConfirm">
						<div class="d-flex justify-content-center align-items-center">
							<b-spinner v-show="isLoading" small></b-spinner>
							<div class="pl-2" style="margin-top: 1px">{{ confirmButtonLabel }}</div>
						</div>
					</b-button>
				</b-col>
			</div>
		</template>
	</b-modal>
</template>
<script>
// import { store } from '@/store';
import languageMessages from '@/mixins/languageMessages';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { isNil, formatFileName } from '@/shared/utils';
import { store } from '@/store';
import {
	timeSheetReport,
	purchaseOrderReport,
	expenseReport,
	userReport,
	expenseItemReport,
	jobRequestGridReportFromTo,
	budgetReport
} from '@/cruds/export.crud';
import { getScripts } from '@/cruds/script.crud';
import globalMixin from '@/mixins/global.mixin';
import axios from 'axios';
// import { generateRandomFilename } from '~utils';
// import moment from 'moment';
import { FILENAME_REPORT, OUTPUT_FORMAT_EXPORT } from '@/shared/constants';
import _ from 'lodash';
import { getFileExtension } from '@/shared/helpers';
import { expenseDematerializationReport } from '@/cruds/expense.crud';

export default {
	name: 'ScriptExportModal',
	mixins: [languageMessages, validationMixin, globalMixin],
	props: {
		value: {
			type: Boolean,
			required: false,
			default: false
		},
		items: {
			type: Array,
			required: false,
			default: () => []
		},
		custom: {
			type: Object,
			required: false,
			default: null
		},
		exportType: {
			type: String,
			required: true,
			default: '' // 'expense', 'po', 'purchaseorder', 'timesheet', 'ts', 'user', 'expenseItem', 'jobRequest', 'budgetPerCategory'
		},
		forInvoice: {
			type: Boolean,
			default: false
		},
		invoice: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		isOpen: {
			get: function () {
				return this.value;
			},
			set: function (value) {
				return value;
			}
		},
		enableCertified() {
			return store.getCurrentProjectConfig().digitalCertifiedExpense;
		},
		confirmButtonLabel() {
			if (this.forInvoice) {
				if (this.sendByMail) {
					return this.FormMSG(298, 'Send');
				} else {
					return this.FormMSG(292, 'Download');
				}
			} else {
				return this.FormMSG(3, 'Confirm');
			}
		},
		canConfirm() {
			if (this.forInvoice) {
				if (!_.isNil(this.reportType) && this.scripts.length <= 1) {
					return true;
				}
				if (!_.isNil(this.reportType) && !_.isNil(this.scriptSelected) && this.scripts.length > 1) {
					return true;
				}
				return false;
			} else {
				if (!_.isNil(this.scriptSelected)) {
					return true;
				}
				return false;
			}
		}
	},
	created() {
		this.reportOptions = [
			{
				id: 0,
				name: this.FormMSG(294, 'Simple export')
			}
		];
	},
	data() {
		return {
			scriptSelected: null,
			isSubmitted: false,
			scripts: [],
			reportType: null,
			reportOptions: [],
			apiImportUrl: 'uploadImportFormatFile',
			openLog: false,
			importLog: '',
			OUTPUT_FORMAT_EXPORT: OUTPUT_FORMAT_EXPORT,
			script: null,
			isLoading: false,
			sendByMail: false,
			customReport: null
		};
	},
	methods: {
		cleanReportData() {
			this.reportType = null;
			this.sendByMail = false;
			this.reportOptions = [
				{
					id: 0,
					name: this.FormMSG(294, 'Simple export')
				}
			];
		},
		async getScripts() {
			this.scripts = await getScripts(store.getCurrentProjectConfig().licenseID, store.getCurrentProjectConfig().id, this.reportType, true);
		},
		initializeInvoiceReport() {
			if (this.forInvoice) {
				if (this.invoice.validated === 8 && this.enableCertified && !this.custom.includeAttachments) {
					let newOptions = [
						...this.reportOptions,
						{
							id: 1,
							name: this.FormMSG(295, 'Digital certified expense')
						}
					];
					this.reportOptions = newOptions;
				} else {
					this.reportType = 0;
				}
			}
		},
		emitEventClose() {
			this.$emit('script-export-modal:closed');
		},
		async sendReport(e) {
			this.isLoading = true;
			e.preventDefault();
			this.isSubmitted = true;

			// this.$v.$touch();
			// if (this.$v.$invalid) {
			// 	return;
			// }
			try {
				if (this.forInvoice) {
					if (this.reportType === 0) {
						await this.manageReport(); // Wait for the async function to complete
					} else if (this.reportType === 1) {
						await this.downloadCertifiedInvoice(this.custom.subjectId, this.sendByMail); // Wait for the async function to complete
					}
				} else {
					await this.manageReport(); // Wait for the async function to complete
				}
			} catch (error) {
				console.error('Error in sendReport:', error); // Handle errors if necessary
			} finally {
				this.isLoading = false;
				this.$emit('script-export-modal:closed');
			}

			// if (this.exportType.toLowerCase() !== this.EXPORTNAME.USER) {
			// this.$emit('script-export-modal:closed');
			// }
		},
		getExtensionFile(filename) {
			return filename.substring(filename.lastIndexOf('.') + 1);
		},
		getFileName(filename) {
			return filename.substring(0, filename.lastIndexOf('.'));
		},
		getFileExtensionForScript(script, scriptSelected, forInvoice) {
			if (forInvoice) {
				return _.isNil(scriptSelected) ? script.ext : getFileExtension(script.fileName);
			} else {
				return getFileExtension(script.fileName);
			}
		},
		async manageReport() {
			this.customReport = {
				..._.omit(this.custom, ['includeAttachments']),
				sendEmail: this.forInvoice ? this.sendByMail : this.custom.sendEmail
			};
			let fileName = '';
			let fileExtension = '';

			if (this.forInvoice) {
				if (_.isNil(this.scriptSelected)) {
					this.script = { id: 0, customExportFileName: null, ext: 'xlsx' };
				} else {
					let scriptSelectedForExport = this.scripts.find((script) => +script.id === +this.scriptSelected);
					this.script = scriptSelectedForExport;
				}
			}

			if (this.exportType.toLowerCase() === this.EXPORTNAME.EXPENSE) {
				await expenseReport(this.customReport, this.scriptSelected, this.custom.includeAttachments)
					.then(async (result) => {
						if (!this.customReport.sendEmail) {
							fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_EXPENSE, this.script.id, this.script.customExportFileName);
							fileExtension = this.getFileExtensionForScript(this.script, this.scriptSelected, this.forInvoice);
							const extension = this.custom.includeAttachments
								? 'zip'
								: this.getExtensionScript(OUTPUT_FORMAT_EXPORT.at(this.script.outputFileFormat), this.script.customExtension, fileExtension);

							await this.forceDownload(result, fileName + '.' + extension);
						} else {
							this.createToastForMobile(this.FormMSG(7, 'Success'), this.FormMSG(8, 'The document has been sent to your email address.'));
						}
						this.$emit('script-export-modal:loading', true);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => (this.isLoading = false));
			} else if (this.exportType.toLowerCase() === this.EXPORTNAME.PO || this.exportType.toLowerCase() === this.EXPORTNAME.PURCHASE_ORDER) {
				await purchaseOrderReport(this.customReport, this.scriptSelected)
					.then(async (result) => {
						if (!this.customReport.sendEmail) {
							fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_PO, this.script.id, this.script.customExportFileName);

							await this.forceDownload(
								result,
								fileName +
									'.' +
									this.getExtensionScript(
										OUTPUT_FORMAT_EXPORT.at(this.script.outputFileFormat),
										this.script.customExtension,
										getFileExtension(this.script.fileName)
									)
							);
						} else {
							this.createToastForMobile(this.FormMSG(7, 'Success'), this.FormMSG(8, 'The document has been sent to your email address.'));
						}
						this.$emit('script-export-modal:loading', true);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => (this.isLoading = false));
			} else if (this.exportType.toLowerCase() === this.EXPORTNAME.TS || this.exportType.toLowerCase() === this.EXPORTNAME.TIMESHEET) {
				await timeSheetReport(this.customReport, this.scriptSelected)
					.then(async (result) => {
						if (!this.customReport.sendEmail) {
							fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_TS, this.script.id, this.script.customExportFileName);

							await this.forceDownload(
								result,
								fileName +
									'.' +
									this.getExtensionScript(
										OUTPUT_FORMAT_EXPORT.at(this.script.outputFileFormat),
										this.script.customExtension,
										getFileExtension(this.script.fileName)
									)
							);
						} else {
							this.createToastForMobile(this.FormMSG(7, 'Success'), this.FormMSG(8, 'The document has been sent to your email address.'));
						}
						this.$emit('script-export-modal:loading', true);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => (this.isLoading = false));
			} else if (this.exportType.toLowerCase() === this.EXPORTNAME.USER) {
				await userReport(this.customReport, this.scriptSelected)
					.then(async (result) => {
						if (!this.customReport.sendEmail) {
							fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_USER, this.script.id, this.script.customExportFileName);

							await this.forceDownload(
								result,
								fileName +
									'.' +
									this.getExtensionScript(
										OUTPUT_FORMAT_EXPORT.at(this.script.outputFileFormat),
										this.script.customExtension,
										getFileExtension(this.script.fileName)
									)
							);
						} else {
							this.createToastForMobile(this.FormMSG(7, 'Success'), this.FormMSG(8, 'The document has been sent to your email address.'));
						}
						this.$emit('script-export-modal:loading', true);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => (this.isLoading = false));
			} else if (this.exportType.toLowerCase() === this.EXPORTNAME.EXPENSE_ITEM) {
				await expenseItemReport(this.customReport, this.scriptSelected)
					.then(async (result) => {
						if (!this.customReport.sendEmail) {
							fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_EXPENSE_ITEM, this.script.id, this.script.customExportFileName);

							await this.forceDownload(
								result,
								fileName +
									'.' +
									this.getExtensionScript(
										OUTPUT_FORMAT_EXPORT.at(this.script.outputFileFormat),
										this.script.customExtension,
										getFileExtension(this.script.fileName)
									)
							);
						} else {
							this.createToastForMobile(this.FormMSG(7, 'Success'), this.FormMSG(8, 'The document has been sent to your email address.'));
						}
						this.$emit('script-export-modal:loading', true);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => (this.isLoading = false));
			} else if (this.exportType.toLowerCase() === this.EXPORTNAME.PO_JOB_REQUEST) {
				await jobRequestGridReportFromTo(
					this.customReport.jobRequestId,
					this.scriptSelected,
					this.customReport.sendEmail,
					this.customReport.contactEmail
				)
					.then(async (result) => {
						if (!this.customReport.sendEmail) {
							fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_JOB_REQUEST, this.script.id, this.script.customExportFileName);

							await this.forceDownload(result, fileName + '.pdf');
						} else {
							this.createToastForMobile(this.FormMSG(7, 'Success'), this.FormMSG(8, 'The document has been sent to your email address.'));
						}
						this.$emit('script-export-modal:loading', true);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => (this.isLoading = false));
			} else if (this.exportType.toLowerCase() === this.EXPORTNAME.BUDGET_PER_CATEGORY) {
				await budgetReport(this.customReport, this.scriptSelected)
					.then(async (result) => {
						if (!this.customReport.sendEmail) {
							fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_BUDGET_PER_CATEGORY, this.script.id, this.script.customExportFileName);

							await this.forceDownload(
								result,
								fileName +
									'.' +
									this.getExtensionScript(
										OUTPUT_FORMAT_EXPORT.at(this.script.outputFileFormat),
										this.script.customExtension,
										getFileExtension(this.script.fileName)
									)
							);
						} else {
							this.createToastForMobile(this.FormMSG(7, 'Success'), this.FormMSG(8, 'The document has been sent to your email address.'));
						}
						this.$emit('script-export-modal:loading', true);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => (this.isLoading = false));
			}
		},
		async downloadCertifiedInvoice(id, sendMail = false) {
			try {
				const resultFile = await expenseDematerializationReport(+id, sendMail);

				if (!sendMail) {
					const url = process.env.VUE_APP_GQL + '/images/' + resultFile;
					axios.get(url, { responseType: 'blob' }).then((response) => {
						const link = window.URL.createObjectURL(new Blob([response.data]));
						const anchor = document.createElement('a');
						anchor.setAttribute('href', link);
						anchor.setAttribute('target', '_blank');
						anchor.setAttribute('download', resultFile);
						document.body.appendChild(anchor);
						anchor.click();
						document.body.removeChild(anchor);
					});
				} else {
					this.createToastForMobile(this.FormMSG(700, 'Success'), this.FormMSG(288, 'The document has been sent to your email address.'));
				}
			} catch (e) {
				this.createToastForMobile(this.FormMSG(701, 'Info'), this.resolveGqlError(e), '', 'info');
			}
		},
		handleCloseLogWindow() {
			this.openLog = false;
			this.$emit('script-export-modal:closed');
		},
		handleScriptSelected(payload) {
			this.script = payload;
		},
		getFileExt(fileName) {
			return getFileExtension(fileName);
		}
	},
	watch: {
		items: {
			handler(items) {
				if (!isNil(items)) {
					this.isSubmitted = false;
					this.scriptSelected = null;
					this.scripts = [
						{
							id: null,
							name: this.FormMSG(5, 'Please select a script...')
						},
						...items
					];
				}
			}
		},
		isOpen: {
			handler(value) {
				if (value) {
					this.initializeInvoiceReport();
				}
			}
		},
		reportType: {
			handler(value) {
				if (value === 0) {
					this.getScripts();
				} else {
					this.scripts = [];
				}
			}
		}
	}
};
</script>
